import * as types from '../mutation-types'
import RegionsApi from "../../api/regions";
import axios from "axios";

// state
export const state = {
    all: []
};

// getters
export const getters = {
    all: state => state.all
};

// mutations
export const mutations = {
    [types.SOURCES_ALL_SET] (state, all) {
        state.all = all;
    }
};

// actions
export const actions = {
    async fetch(context) {
        const { data } = await axios.get('/api/sources?columns[]=id&columns[]=name&columns[]=platform_id');
        context.commit(types.SOURCES_ALL_SET, data);
    },
};
